export const MAX_VOLUME = 10000000;
export function computeIndicativeMSO(
  totalAnnualVolume: number | null | undefined,
  msoProductId: number,
  msoTargetDays: Array<{ msoProductId: number; noOfDays: number; fuelTypeThreshHold: number }>
): number | null {
  const config = msoTargetDays.find(t => t.msoProductId === msoProductId);
  if (!config || totalAnnualVolume == null) return null;

  const { noOfDays, fuelTypeThreshHold } = config;

  if (totalAnnualVolume <= fuelTypeThreshHold) return null;

  return Math.ceil(totalAnnualVolume * (noOfDays / 365));
}